export enum PersonInformationModifier {
  POST = 'post',
  THREADLIST = 'threadlist',
  TICKET = 'ticket',
}
